import React from 'react'
import { withRouter } from "react-router-dom"
import Terms from './terms/Terms'
import ChangeBodyClass from '../common/ChangeBodyClass'

class TermsOfUseAgreement extends React.Component {
  render() {
    return (
      <div className="app-layout">
        <ChangeBodyClass bodyClassname="mfc-terms-container" />

        <div className="content">
          <Terms />
          <button className="btn-link normal" onClick={() => this.props.history.goBack()}>前のページへ戻る</button>
        </div>
      </div>
    )
  }
}

export default withRouter(TermsOfUseAgreement)
